import "./App.css";
import RouteComponent from "./Router/router";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import ScrollToTop from "./scrolltotop";
import "./i18n"; // 👈 This makes sure i18n is loaded once globally
import ScrollToTopButton from "./Components/ScrollToTopButton";

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <RouteComponent />
      <ScrollToTopButton/>
      <Footer />
    </>
  );
}

export default App;
